var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.062 2.108V4.18h23.876V.037H.062v2.071zM.062 12.462v2.07h23.876v-4.14H.062v2.07zM.062 22.298v2.07h23.876v-4.14H.062v2.07z"
  })));
};
export default SvgBurger;